import "@babel/polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";

import axios from "./utils/request";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios)
import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "./store";
import "@/styles/common.scss";
import "@/components/global/custom-img/custom-img.js";

import Base64 from "@/utils/base64.js";
Vue.prototype.$Base64 = Base64;

// import { Message } from 'element-ui';
// Vue.prototype.$message = function (msg) {
//   Message({ ...msg, offset: 200 })
// }

import animated from "animate.css";
Vue.use(animated);

import "./permission";
import "@/plugins";
//百度地图
import BaiduMap from "vue-baidu-map";

Vue.use(BaiduMap, {
  ak: "A6Wcvb66bywWrUSRq4OsyxbTYvNNMisb",
});

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


import global_ from "./components/global/Global"; //引用文件
Vue.prototype.GLOBAL = global_; //挂载到Vue实例上面
